import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CATALOG_BLOCKS, DECO_CRUMBS } from './salesData';

/**
 * PRODUCTO. Qué es exactamente: 2 tomos, 100 recetas repartidas en 5
 * categorías comerciales. Cada categoría tiene su propio universo visual,
 * pero la sección se mantiene compacta y escaneable.
 */
export function CatalogSection() {
  return <section id="catalogo" className="relative scroll-mt-24 overflow-hidden bg-cream pb-0 pt-14 sm:pt-20" aria-labelledby="catalog-title" data-id="element-28" data-mp="22cvtmeanbt1w">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-29" data-mp="1xgeukp1wrua1">
        <div className="grid gap-9 lg:grid-cols-12 lg:gap-14" data-id="element-30" data-mp="2ca9z5iv16xff">
          <div className="lg:col-span-5" data-id="element-31" data-mp="27crpfq96we6d">
            <SectionTag data-id="element-32" data-mp="27d1enbmeuhb0">El catálogo</SectionTag>
            <h2 id="catalog-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-33" data-mp="hxk0yoxmr228">
              2 tomos. 100 recetas. Un catálogo entero de cookies.
            </h2>
            <p className="mt-4 max-w-md font-sans text-[0.95rem] leading-relaxed text-charcoal/65" data-id="element-34" data-mp="2hdivkwjq8lyw">
              No es una selección de diez recetas repetidas. Son cien variedades distintas,
              ordenadas por su rol comercial: las que sostienen la venta diaria, las que enamoran al
              partirse y las que suben el ticket.
            </p>
          </div>

          <ul className="lg:col-span-7" data-id="element-35" data-mp="3038spqaypjtz">
            {CATALOG_BLOCKS.map((block, index) => <motion.li key={block.id} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 4) * 0.035
          }} className="flex items-center gap-4 border-b border-warm/80 py-4 first:border-t sm:gap-6 sm:py-5" data-id="element-36" data-mp="350r03c9bzqzv" data-mpi={index}>
                <img src={block.image} alt={block.alt} loading="lazy" decoding="async" className="h-16 w-16 shrink-0 rounded-full object-cover shadow-bakery-sm sm:h-[5.5rem] sm:w-[5.5rem]" data-id="element-37" data-mp="2mzwe2qwvxows" />
                <div className="min-w-0" data-id="element-38" data-mp="2qzx4l9x9dqk7">
                  <div className="flex items-baseline gap-2.5" data-id="element-39" data-mp="2r31bwg60t2f3">
                    <span className="font-display text-[1.6rem] leading-none tabular-nums text-caramel sm:text-[2.1rem]" data-id="element-40" data-mp="35wef5yxmj15p">
                      {block.count}
                    </span>
                    <h3 className="font-display text-[1.02rem] leading-tight text-charcoal sm:text-[1.3rem]" data-id="element-41" data-mp="3eozhy5kv0x8w">
                      {block.title}
                    </h3>
                  </div>
                  <p className="mt-1.5 max-w-lg font-sans text-[0.85rem] leading-relaxed text-charcoal/55 sm:text-[0.92rem]" data-id="element-42" data-mp="3opi8fj6xjbzs">
                    {block.body}
                  </p>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </div>

      {/* Migas y chips como textura de cierre, cruzando hacia la sección siguiente. */}
      <img src={DECO_CRUMBS} alt="" aria-hidden loading="lazy" className="pointer-events-none mt-10 h-14 w-full object-cover opacity-70 mix-blend-multiply sm:h-20" data-id="element-43" data-mp="3td872omnqxtq" />
    </section>;
}